import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ContentContainer } from '@snsw/react-component-library';

const DefaultLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  & footer {
    margin-top: auto;
  }
  @media print {
    @page {
      size: 330mm 427mm;
      margin: 14mm;
    }
  }
`;

const DefaultLayout = (props) => {
  const { children, topbar, navigation, footer, className } = props;
  return (
    <DefaultLayoutWrapper>
      {topbar}
      {navigation}
      <main className={className}>
        <ContentContainer>{children}</ContentContainer>
      </main>
      {footer}
    </DefaultLayoutWrapper>
  );
};

DefaultLayout.propTypes = {
  topbar: PropTypes.element,
  navigation: PropTypes.element,
  footer: PropTypes.element,
};

DefaultLayout.defaultProps = {
  topbar: null,
  navigation: null,
  footer: null,
};

export default DefaultLayout;
